import { Metamodel } from 'app/model/base/model';
import { Named } from 'app/model/base/named';
import { IModel } from 'app/model/base/annotation';
import { CompressionReadSettings } from '../compression-read-settings/compression-read-settings';

@Metamodel.model({
    abstract: true
})

export abstract class FormatReadSettings extends Named {
    public static readonly MODEL: IModel;
    // for dataset v2
    @Metamodel.attribute({
        type: CompressionReadSettings.MODEL
    })
    public compressionProperties?: CompressionReadSettings;
}
